export default __webpack_public_path__ + "static/media/triangle-arrow.5ecb8ac3.svg";